import React from 'react'
import SignInForm from 'components/organisms/SignInForm'

const SignIn = () => <SignInForm />

export default SignIn
